function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#292A2B",
  fillRule: "evenodd",
  d: "M8 14c-1.173 0-2.193.138-3 .307V22a1 1 0 1 1-2 0V4.196c0-.786.463-1.496 1.22-1.702C5.1 2.254 6.41 2 8 2c1.5 0 2.75.5 4 1s2.5 1 4 1c1.363 0 2.313-.206 2.944-.432.42-.15 1.056.194 1.056.64v9.964c0 .53-.22 1.04-.704 1.256-.608.271-1.651.572-3.296.572-1.5 0-2.75-.5-4-1s-2.5-1-4-1",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-flag.svg";
export { SvgComponent as ReactComponent };